import axios from "axios";
import AuthService from "../services/AuthService";
import { retryApiCall } from "../utils/retryApi.util";
import createAxiosInstance from "../interceptor/axiosInterceptor";
import appConfig from '@/config/appConfig';
const instance = createAxiosInstance(appConfig.VUE_APP_CAMPAIGNS_API_URL);
const assessmentInstance = createAxiosInstance(appConfig.VUE_APP_ASSESSMENT_API_URL);

export default {
  updateCampaignJobSkeekerAudeince: async function (campaignId, userId) {
    try {
      const response = await instance.put(
        "/updateCampaignJobSkeekerAudeince?userId=" +
          userId +
          "&campaignId=" +
          campaignId,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },

  addJobSeekerToCampign: async function (
    userId,
    campaignId,
    subjects,
    level,
    schools
  ) {
    try {
      const response = await instance.post(
        "/addJobseekerToCampaign",

        {
          userId: userId,
          campaignId: campaignId,
          subjects: subjects,
          level: level,
          schools: schools,
        }
      );
      return response;
    } catch (error) {
      console.log(error.response);
      alert(error.response.data.result);
      return error.response;
    }
  },
  checkCampaignEligibility: async function (userId,campaignId) {
    try {
      const response = await instance.get("/checkCampaignEligibility?userId=" + userId +"&campaignId=" + campaignId);
      return response;
    } catch (error) {
      return error.response;
    }
  },
  isCampaignExpired: async function (campaignId){
   try{
    const response = await instance.get("campaignExpiryStatus?id="+campaignId)
    return response
   } catch (error){
    return error.response;
   }
  },
  getMainsSlotsBySchool: async function (schoolId) {
    try {
      const response = await instance.get("/getSlots?schoolId=" + schoolId, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  submitMainsSlot: async function (payload) {
    try {
      const response = await instance.post("/bookMiansSlot", payload, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  updateCampaignUserStatus: async function (payload) {
    try {
      const response = await  retryApiCall(() => instance.put("/campaignStatus", payload),
    );
      return response;
    } catch (error) {
      console.info("campaignStatus error", error);
      console.info('Error: ', error);
      return error.response;
    }
  },
  getSingleCampaign: async function (campaignId) {
    try {
      const response = await instance.get("/campaign?id=" + campaignId);
      return response;
    } catch (error) {
      return error.response;
    }
  },
  submitDynamicQuestion: async function (
    campaignId,
    assessmentType,
    userId,
    questions,
    testType,
    timeTaken,
    isQuit,
    currentTestRoundIndex = 0 
  ) {
    const data = {
      campaignId,
      assessmentType,
      userId,
      questions,
      testType,
      timeTaken,
      isQuit,
      currentTestRoundIndex
    }
    try {
      const response = await retryApiCall(() => assessmentInstance.post("save-assessment-data",
        data), 4, 1200);
      return response;
    } catch (error) {
      console.info("submitDynamicQuestion error", error);
      return error.response;
    }
  },
  submitCampaignAssessment: async function (
    campaignId,
    userId,
    questions,
    testType,
    timeTaken,
    isQuit
  ) {
    try {
      const response = await retryApiCall(() => instance.post(
        "submitCampaignAssessment",
        {
          campaignId: campaignId,
          userId: userId,
          questions: questions,
          testType: testType,
          timeTaken: timeTaken,
          isTestQuit: isQuit,
        },
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      ),
      4, // Max tries 4
      1200);
      // if (testType == "MAINS") {
        const leaugeRes = await instance.post("audeinceLeaugeUpdate", {
          campaignId: campaignId,
          userId: userId,
          testType: testType,
        });
        console.log("leaugeRes", leaugeRes);
      // }
      return response;
    } catch (error) {
      console.info("submitCampaignAssessment error", error);
      return error.response;
    }
  },
  deleteDemoVideo : async function(
    campaignId,
    userId,
    subject
  ){
    try {
      const deleteDemoDataRef = await instance.post('deleteDemoVideo' ,{
        campaignId: campaignId,
        userId: userId,
        subject: subject,
      },
      );
      return deleteDemoDataRef;
    } catch (error) {
      return error.response;
    }
  },
  sendInviteFromBroswer : async function (data) {
        console.log('role data',data)
        try {
            const response = await instance.post('sendInviteFromBroswer',data,
            {
                headers: {
                    'Authorization': AuthService.getToken()
                  }
            })
            return response;
        } catch (error) {
            return error.response;
        }
  },
  fetchCampaignByRoleAndLocation: async function (audienceRolesId,school) {
    try {
      const response = await instance.get("/fetchCampaignByRoleAndLocation?audienceRolesId=" + audienceRolesId +"&school=" + school);
      return response;
    } catch (error) {
      return error.response;
    }
  },

  fetchQuestionNonAdaptiveTest: async function (userId, campaignId) {
    try {
      const response = await instance.post("/fetchQuestionNonAdaptiveTest", {
        userId: userId,
        campaignId: campaignId,
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getPerformanceReport(userId, campaignId){
    try{
      const response =  await instance.get(`getPerformanceReport?userId=${userId}&campaignId=${campaignId}`);
      return response.data;
    }
    catch(error){
      return error
    }
  },
  submitDemo: async function(userId, campaignId, currentTestRoundIndex){
    try {
      const response = await instance.post("/submitDemo", {
        userId: userId,
        campaignId: campaignId,
        currentTestRoundIndex: currentTestRoundIndex
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async generateReport(htmlContent, reportType, fileName, userId, campaignId){
    try{
      const response =  await instance.post("generate-report",{
        htmlContent,
        reportType,
        fileName,
        userId,
        campaignId
      },{
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async dispatchPsychometryReport( htmlContent, reportType, fileName, assessmentResultId, campaignId ){
    try{
      const response = await instance.post('/dispatch-psychometry-task', 
        { htmlContent, reportType, fileName, assessmentResultId, campaignId }
      )

      return response.data;
    }
    catch(error){
      console.error('Error dispatching psychometry report task:', error.message || error);
    }
  },

  async saveDemoDetails(campaignId,userId,videoData,topics, timeTakenInMins) {
    try {
      const response = await instance.post("/saveDemoDetails", {
        userId,
        campaignId,
        videoData,
        topics,
        timeTakenInMins
      }
    );
      return response;
    } catch (error) {
      return error.response
    }
  },
  async getCampaignMetaData(campaignId){
    try {
      const response = await instance.get(`fetchCampaignMetaData?campaignId=${campaignId}`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },

  async stashThumbnailURL(payload){
    try{
      const response = await instance.post(
        'stash-thumbnail-url',
        payload,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response.data;
    }
    catch(error){
      return error.response;
    }
  }
}

